import { render, staticRenderFns } from "./checkout-validation-btn.vue?vue&type=template&id=3475b3e0&"
import script from "./checkout-validation-btn.vue?vue&type=script&lang=js&"
export * from "./checkout-validation-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports